import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const subscriptionIcon = () => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="20pt" height="24pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" >
      <path
        d="M1345 4826 c-150 -48 -250 -171 -263 -322 l-5 -63 -261 -3 -261 -3
-61 -28 c-77 -36 -145 -104 -181 -182 l-28 -60 0 -1365 0 -1365 28 -60 c36
-78 104 -146 181 -182 l61 -28 261 -3 261 -3 5 -63 c11 -129 94 -248 212 -303
l61 -28 547 0 548 0 32 33 c28 28 33 39 33 82 0 43 -5 54 -33 82 l-32 33 -530
5 -530 5 -32 33 -33 32 0 1730 0 1730 33 32 32 33 930 0 930 0 32 -33 33 -32
3 -1093 2 -1092 -72 -37 c-141 -73 -286 -203 -378 -339 -62 -90 -127 -235
-157 -346 -23 -87 -26 -117 -26 -263 0 -146 3 -176 26 -263 30 -111 95 -256
157 -346 55 -83 158 -190 239 -252 92 -70 267 -154 386 -186 89 -23 118 -26
265 -26 147 0 176 3 265 26 235 63 452 207 596 396 70 92 154 267 186 386 23
89 26 118 26 265 0 146 -3 176 -26 263 -30 111 -95 256 -157 347 -55 81 -164
195 -234 245 l-55 40 -3 955 -3 955 -28 61 c-36 77 -104 145 -182 181 l-60 28
-261 3 -261 3 -5 63 c-9 112 -74 220 -169 281 -87 56 -63 55 -1073 54 -723 0
-940 -3 -971 -13z m-265 -2026 l0 -1401 -245 3 -245 3 -32 33 -33 32 0 1329 0
1329 25 27 c14 15 34 31 45 35 11 5 125 9 253 9 l232 1 0 -1400z m3002 1362
l33 -32 3 -876 c2 -834 1 -876 -15 -869 -85 32 -197 49 -338 49 -82 1 -162 -2
-177 -7 l-28 -7 0 890 0 891 245 -3 245 -3 32 -33z m-192 -1973 c93 -14 213
-58 300 -108 100 -58 240 -201 297 -301 149 -266 149 -574 0 -840 -57 -102
-206 -250 -307 -307 -267 -149 -574 -149 -840 0 -102 57 -250 206 -307 307
-149 267 -149 573 0 840 57 101 205 250 307 307 170 95 366 132 550 102z"
      />
      <path
        d="M4220 1794 c-8 -4 -147 -137 -307 -298 l-293 -291 -155 155 -155 155
-50 0 c-43 0 -54 -5 -82 -33 -28 -28 -33 -39 -33 -82 l0 -50 213 -212 212
-213 50 0 50 0 352 353 353 352 0 50 c0 42 -5 54 -31 81 -31 30 -89 46 -124
33z"
      />
      <path
        d="M1715 4271 c-11 -5 -31 -21 -45 -36 l-25 -27 0 -449 0 -449 33 -32
32 -33 610 0 610 0 32 33 33 32 0 450 0 450 -33 32 c-28 28 -40 33 -80 33 -45
0 -56 -6 -181 -99 l-132 -99 -100 99 c-99 99 -100 99 -149 99 -49 0 -50 0
-149 -99 l-100 -99 -130 97 c-134 100 -177 119 -226 97z m703 -373 c91 -91 93
-93 140 -93 44 0 57 6 125 58 l77 57 0 -220 0 -220 -440 0 -440 0 0 220 0 220
77 -57 c68 -52 81 -58 125 -58 47 0 49 1 140 93 51 50 95 92 98 92 2 0 46 -42
98 -92z"
      />
      <path
        d="M2275 2671 c-46 -20 -69 -59 -73 -126 -4 -58 -6 -64 -30 -70 -14 -3
-53 -34 -88 -69 -67 -67 -94 -128 -94 -211 0 -143 113 -269 275 -305 67 -15
134 -46 141 -65 18 -45 -26 -89 -87 -87 -25 1 -41 11 -73 47 -49 55 -93 67
-149 40 -36 -17 -67 -65 -67 -104 0 -56 68 -150 133 -186 33 -18 35 -21 39
-82 3 -56 8 -68 36 -96 28 -27 39 -32 82 -32 43 0 54 5 82 32 28 28 33 40 36
97 4 59 6 65 30 71 14 3 53 34 88 69 67 67 94 128 94 211 0 143 -113 269 -275
305 -67 15 -134 46 -141 65 -11 29 5 62 39 78 46 22 75 12 123 -42 39 -43 45
-46 92 -46 42 0 56 5 81 29 57 55 51 129 -18 208 -22 24 -55 52 -74 63 -33 18
-35 21 -39 82 -3 55 -8 68 -34 94 -33 33 -92 46 -129 30z"
      />
    </g>
  </svg>
);

export const SubscriptionIcon = (props: Partial<CustomIconComponentProps>) => <Icon component={subscriptionIcon} {...props} />;